import React from 'react'

export default function Header() {
  return (
    <div className="header">
        <i class="fa-solid fa-earth-africa"></i>
        <h2 className="header-text">my travel journal</h2>
    </div>
  )
}
